import Repository from '../Repository'

const resource = '/a/settings'
export default {
    fetchAlerts(){
        return Repository.get(`${resource}/alerts`) 
    },
    createAlert(){
        return Repository.post(`${resource}/alerts/`)
    },
    deleteAlert(id){
        return Repository.delete(`${resource}/alerts/${id}`)
    },
    saveAlert(id,params){
        return Repository.put(`${resource}/alerts/${id}`,params)
    },
    fetchUserList(){
        return Repository.get(`${resource}/users`) 
    },
    fetchUAlerts(){
        return Repository.get(`${resource}/ualerts`) 
    },
    createUAlert(){
        return Repository.post(`${resource}/ualerts/`)
    },
    deleteUAlert(id){
        return Repository.delete(`${resource}/ualerts/${id}`)
    },
    saveUAlert(id,params){
        return Repository.put(`${resource}/ualerts/${id}`,params)
    }
    
}